module.exports = __webpack_public_path__ + "img/shopIcon2.47c07463.png";